import api from './api';

const overtimeService = {
  getAll: async (startDate, endDate) => {
    const response = await api.get('/overtime', {
      params: { start_date: startDate, end_date: endDate }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/overtime', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/overtime/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/overtime/${id}`);
    return response.data;
  }
};

export default overtimeService;
